import jsPDF from "jspdf";
import { formatarDataDbParaBr } from "../../../../utils/Masks";

export interface ComprovanteInscricaoData {
  nomeInscrito?: string;
  cpfInscrito?: string;
  dataHoraInscricao?: string;
  nomeAcao: string;
  nomeTurma: string;
  dataInicio: string;
  dataFim: string;
  horaInicio?: string | null;
  horaFim?: string | null;
  modalidade?: string | null;
  cargaHoraria?: number | null;
  endereco?: string | null;
  link?: string | null;
  observacoes?: string | null;
}

export const formatarHoraComprovante = (hora: string | null | undefined): string => {
  if (!hora) {
    return "";
  }

  const [hh, mm] = hora.split(":");
  if (!hh || !mm) {
    return hora;
  }

  return `${hh}:${mm}`;
};

const montarPeriodoTurma = (dados: ComprovanteInscricaoData) => (
  dados.dataInicio === dados.dataFim
    ? formatarDataDbParaBr(dados.dataInicio)
    : `${formatarDataDbParaBr(dados.dataInicio)} a ${formatarDataDbParaBr(dados.dataFim)}`
);

const montarHorarioTurma = (dados: ComprovanteInscricaoData) => (
  dados.horaInicio && dados.horaFim
    ? `${formatarHoraComprovante(dados.horaInicio)} às ${formatarHoraComprovante(dados.horaFim)}`
    : "-"
);

export const montarHtmlComprovanteInscricao = (dados: ComprovanteInscricaoData): string => {
  const periodoTurma = montarPeriodoTurma(dados);
  const horarioTurma = montarHorarioTurma(dados);
  const linkTurma = dados.link?.trim();
  const localTurma = linkTurma || dados.endereco || "-";
  const localTurmaLabel = linkTurma ? "Link de Acesso" : "Endereço";
  const observacoesTurma = dados.observacoes?.trim();
  const observacoesHtml = observacoesTurma
    ? `
      <tr>
        <td style="padding: 15px 20px; background-color: #FFFFFF;">
          <span style="font-size: 11px; color: #6484FA; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">Observações</span><br>
          <span style="font-size: 14px; color: #263672; font-weight: 600; display: inline-block; margin-top: 4px; line-height: 1.5; white-space: pre-wrap;">${observacoesTurma}</span>
        </td>
      </tr>`
    : "";

  return `
    <!DOCTYPE html>
    <html lang="pt-BR">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Inscrição Confirmada - SISCAP</title>
      </head>
      <body style="margin: 0; padding: 0; background-color: #F4F5F7; font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;">
        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #F4F5F7; padding: 40px 20px;">
          <tr>
            <td align="center">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width: 600px; background-color: #FFFFFF; border-radius: 12px; box-shadow: 0 4px 10px rgba(0,0,0,0.05); overflow: hidden;">
                <tr>
                  <td align="center" style="padding: 40px 20px 20px;">
                    <div style="color: #6484FA; font-size: 11px; font-weight: bold; line-height: 1.3; letter-spacing: 0.5px;">
                      Sistema de Gestão<br>de Capacitações e<br>Apoio Técnico
                    </div>
                    <div style="color: #6484FA; font-size: 26px; font-weight: 900; margin-top: 16px; letter-spacing: 1px;">
                      SISCAP
                    </div>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding: 10px 40px 20px;">
                    <h2 style="color: #263672; font-size: 22px; margin: 0; font-weight: 700;">Inscrição Confirmada!</h2>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding: 0 40px 25px; color: #263672; font-size: 16px; line-height: 1.6;">
                    <p style="margin: 0;">Sua inscrição foi realizada com sucesso! Confira abaixo os detalhes da sua inscrição:</p>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding: 0 40px 30px;">
                    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border: 1px solid #DCE3FE; border-radius: 8px; overflow: hidden; text-align: left;">
                      <tr>
                        <td style="padding: 15px 20px; border-bottom: 1px solid #DCE3FE; background-color: #FAFBFF;">
                          <span style="font-size: 11px; color: #6484FA; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">Nome do Participante</span><br>
                          <span style="font-size: 15px; color: #263672; font-weight: 700; display: inline-block; margin-top: 4px; line-height: 1.4;">${dados.nomeInscrito || "-"}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 15px 20px; border-bottom: 1px solid #DCE3FE; background-color: #FFFFFF;">
                          <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                              <td width="50%" valign="top">
                                <span style="font-size: 11px; color: #6484FA; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">CPF do Participante</span><br>
                                <span style="font-size: 14px; color: #263672; font-weight: 600; display: inline-block; margin-top: 4px;">${dados.cpfInscrito || "-"}</span>
                              </td>
                              <td width="50%" valign="top">
                                <span style="font-size: 11px; color: #6484FA; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">Data e Hora da Inscrição</span><br>
                                <span style="font-size: 14px; color: #263672; font-weight: 600; display: inline-block; margin-top: 4px;">${dados.dataHoraInscricao || "-"}</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 15px 20px; border-bottom: 1px solid #DCE3FE; background-color: #FAFBFF;">
                          <span style="font-size: 11px; color: #6484FA; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">Nome da Ação</span><br>
                          <span style="font-size: 15px; color: #263672; font-weight: 700; display: inline-block; margin-top: 4px; line-height: 1.4;">${dados.nomeAcao || "-"}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 15px 20px; border-bottom: 1px solid #DCE3FE; background-color: #FFFFFF;">
                          <span style="font-size: 11px; color: #6484FA; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">Nome da Turma</span><br>
                          <span style="font-size: 14px; color: #263672; font-weight: 600; display: inline-block; margin-top: 4px; line-height: 1.4;">${dados.nomeTurma || "-"}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 15px 20px; border-bottom: 1px solid #DCE3FE; background-color: #FAFBFF;">
                          <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                              <td width="50%" valign="top">
                                <span style="font-size: 11px; color: #6484FA; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">Período</span><br>
                                <span style="font-size: 14px; color: #263672; font-weight: 600; display: inline-block; margin-top: 4px;">${periodoTurma}</span>
                              </td>
                              <td width="50%" valign="top">
                                <span style="font-size: 11px; color: #6484FA; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">Horário</span><br>
                                <span style="font-size: 14px; color: #263672; font-weight: 600; display: inline-block; margin-top: 4px;">${horarioTurma}</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 15px 20px; border-bottom: 1px solid #DCE3FE; background-color: #FFFFFF;">
                          <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                              <td width="50%" valign="top">
                                <span style="font-size: 11px; color: #6484FA; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">Modalidade</span><br>
                                <span style="font-size: 14px; color: #263672; font-weight: 600; display: inline-block; margin-top: 4px;">${dados.modalidade || "-"}</span>
                              </td>
                              <td width="50%" valign="top">
                                <span style="font-size: 11px; color: #6484FA; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">Carga Horária</span><br>
                                <span style="font-size: 14px; color: #263672; font-weight: 600; display: inline-block; margin-top: 4px;">${dados.cargaHoraria ?? "-"} horas</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 15px 20px; background-color: #FAFBFF;${observacoesTurma ? " border-bottom: 1px solid #DCE3FE;" : ""}">
                          <span style="font-size: 11px; color: #6484FA; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">${localTurmaLabel}</span><br>
                          <span style="font-size: 14px; color: #263672; font-weight: 600; display: inline-block; margin-top: 4px; line-height: 1.4;">${localTurma}</span>
                        </td>
                      </tr>
                      ${observacoesHtml}
                    </table>
                  </td>
                </tr>
              </table>
              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width: 600px;">
                <tr>
                  <td align="center" style="padding: 20px; color: #A0A0A0; font-size: 12px;">
                    Este é um e-mail automático, por favor não responda.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </body>
    </html>
  `;
};

export const imprimirComprovanteInscricao = (dados: ComprovanteInscricaoData): void => {
  const janela = window.open("", "_blank", "width=900,height=700");
  if (!janela) {
    return;
  }

  janela.document.write(montarHtmlComprovanteInscricao(dados));
  janela.document.close();

  const triggerPrint = () => {
    janela.focus();
    janela.print();
    janela.close();
  };

  if (janela.document.readyState === "complete") {
    setTimeout(triggerPrint, 250);
    return;
  }

  janela.onload = () => {
    setTimeout(triggerPrint, 250);
  };
};

export const salvarPdfComprovanteInscricao = async (dados: ComprovanteInscricaoData): Promise<void> => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const cardX = 48;
  const cardY = 36;
  const cardWidth = pageWidth - (cardX * 2);
  const cardPaddingX = 40;
  const cardPaddingY = 28;
  const innerWidth = cardWidth - (cardPaddingX * 2);
  const rowLabelColor = "#6484FA";
  const rowTextColor = "#263672";
  const borderColor = "#DCE3FE";
  const lightFill = "#FAFBFF";
  const whiteFill = "#FFFFFF";
  let currentY = cardY + cardPaddingY;

  const periodoTurma = montarPeriodoTurma(dados);
  const horarioTurma = montarHorarioTurma(dados);
  const linkTurma = dados.link?.trim();
  const localTurma = linkTurma || dados.endereco || "-";
  const localTurmaLabel = linkTurma ? "Link de Acesso" : "Endereço";
  const observacoesTurma = dados.observacoes?.trim() || "";

  const drawLabel = (text: string, x: number, y: number) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(rowLabelColor);
    doc.text(text.toUpperCase(), x, y);
  };

  const drawValue = (
    text: string,
    x: number,
    y: number,
    maxWidth: number,
    fontSize = 14,
  ) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(fontSize);
    doc.setTextColor(rowTextColor);
    const lines = doc.splitTextToSize(text || "-", maxWidth);
    doc.text(lines, x, y);
    return lines.length;
  };

  const drawSingleRow = (
    label: string,
    value: string,
    y: number,
    backgroundColor: string,
    isLast = false,
  ) => {
    const textWidth = innerWidth - 40;
    const fontSize = label === "Nome da Ação" ? 15 : 14;
    const valueLines = doc.splitTextToSize(value || "-", textWidth);
    const rowHeight = 40 + (Math.max(valueLines.length - 1, 0) * 16);

    doc.setFillColor(backgroundColor);
    doc.rect(cardX + cardPaddingX, y, innerWidth, rowHeight, "F");

    drawLabel(label, cardX + cardPaddingX + 20, y + 18);
    drawValue(value, cardX + cardPaddingX + 20, y + 36, textWidth, fontSize);

    if (!isLast) {
      doc.setDrawColor(borderColor);
      doc.line(cardX + cardPaddingX, y + rowHeight, cardX + cardPaddingX + innerWidth, y + rowHeight);
    }

    return rowHeight;
  };

  const drawDoubleRow = (
    left: { label: string; value: string },
    right: { label: string; value: string },
    y: number,
    backgroundColor: string,
    isLast = false,
  ) => {
    const columnWidth = (innerWidth - 56) / 2;
    const leftLines = doc.splitTextToSize(left.value || "-", columnWidth);
    const rightLines = doc.splitTextToSize(right.value || "-", columnWidth);
    const rowHeight = 40 + ((Math.max(leftLines.length, rightLines.length) - 1) * 16);

    doc.setFillColor(backgroundColor);
    doc.rect(cardX + cardPaddingX, y, innerWidth, rowHeight, "F");

    drawLabel(left.label, cardX + cardPaddingX + 20, y + 18);
    drawValue(left.value, cardX + cardPaddingX + 20, y + 36, columnWidth, 14);

    drawLabel(right.label, cardX + cardPaddingX + 36 + columnWidth, y + 18);
    drawValue(right.value, cardX + cardPaddingX + 36 + columnWidth, y + 36, columnWidth, 14);

    if (!isLast) {
      doc.setDrawColor(borderColor);
      doc.line(cardX + cardPaddingX, y + rowHeight, cardX + cardPaddingX + innerWidth, y + rowHeight);
    }

    return rowHeight;
  };

  doc.setFillColor("#F4F5F7");
  doc.rect(0, 0, pageWidth, pageHeight, "F");

  doc.setFillColor("#FFFFFF");
  doc.roundedRect(cardX, cardY, cardWidth, 568, 12, 12, "F");

  doc.setFont("helvetica", "bold");
  doc.setTextColor("#6484FA");
  doc.setFontSize(11);
  doc.text(["Sistema de Gestão", "de Capacitações e", "Apoio Técnico"], pageWidth / 2, currentY, {
    align: "center",
    baseline: "top",
  });
  currentY += 64;

  doc.setFontSize(26);
  doc.text("SISCAP", pageWidth / 2, currentY, { align: "center" });
  currentY += 48;

  doc.setTextColor("#263672");
  doc.setFontSize(22);
  doc.text("Inscrição Confirmada!", pageWidth / 2, currentY, { align: "center" });
  currentY += 30;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(16);
  const introLines = doc.splitTextToSize(
    "Sua inscrição foi realizada com sucesso! Confira abaixo os detalhes da sua inscrição:",
    innerWidth - 8,
  );
  doc.text(introLines, pageWidth / 2, currentY, { align: "center" });
  currentY += introLines.length * 20 + 20;

  const tableY = currentY;
  let rowsHeight = 0;
  rowsHeight += drawSingleRow("Nome do Participante", dados.nomeInscrito || "-", tableY + rowsHeight, lightFill);
  rowsHeight += drawDoubleRow(
    { label: "CPF do Participante", value: dados.cpfInscrito || "-" },
    { label: "Data e Hora da Inscrição", value: dados.dataHoraInscricao || "-" },
    tableY + rowsHeight,
    whiteFill,
  );
  rowsHeight += drawSingleRow("Nome da Ação", dados.nomeAcao || "-", tableY + rowsHeight, lightFill);
  rowsHeight += drawSingleRow("Nome da Turma", dados.nomeTurma || "-", tableY + rowsHeight, whiteFill);
  rowsHeight += drawDoubleRow(
    { label: "Período", value: periodoTurma },
    { label: "Horário", value: horarioTurma },
    tableY + rowsHeight,
    lightFill,
  );
  rowsHeight += drawDoubleRow(
    { label: "Modalidade", value: dados.modalidade || "-" },
    { label: "Carga Horária", value: `${dados.cargaHoraria ?? "-"} horas` },
    tableY + rowsHeight,
    whiteFill,
  );
  rowsHeight += drawSingleRow(localTurmaLabel, localTurma, tableY + rowsHeight, lightFill, !observacoesTurma);

  if (observacoesTurma) {
    rowsHeight += drawSingleRow("Observações", observacoesTurma, tableY + rowsHeight, whiteFill, true);
  }

  doc.setDrawColor(borderColor);
  doc.roundedRect(cardX + cardPaddingX, tableY, innerWidth, rowsHeight, 8, 8, "S");

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor("#A0A0A0");
  doc.text("Este é um e-mail automático, por favor não responda.", pageWidth / 2, Math.min(tableY + rowsHeight + 28, pageHeight - 24), {
    align: "center",
  });

  doc.save("comprovante-inscricao.pdf");
};
